"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ = require("..");
var _BadLocationError = _interopRequireDefault(require("../ErrorClasses/BadLocationError"));
var _UnknownGpsReadingPropError = _interopRequireDefault(require("../ErrorClasses/UnknownGpsReadingPropError"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */

const isProd = _.MiscUtils.isProd();

// Mutates in place
const cleanEmptyValues = obj => {
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    if ([null, undefined].includes(value)) {
      delete obj[key];
    }
  });
};
const getWarningErrorProps = propsObject => {
  const {
    old_reading1,
    old_reading2,
    ...errorProps
  } = propsObject;
  const warningProps = {
    old_reading1,
    old_reading2
  };
  cleanEmptyValues(warningProps);
  return {
    warningProps,
    errorProps
  };
};
const propsWarned = {};
const getPropsNotWarnedYet = props => {
  return props.filter(prop => !propsWarned[prop]);
};

// eslint-disable-next-line no-unused-vars
const tryRaiseBadPropsErrorOrWarning = function (props, title) {
  let error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return undefined;

  // if (props.length === 0) {
  // 	return;
  // }

  // const message = `Unkown propert(y|ies) for ${title}: "${props.join('", "')}"`;

  // if (error) {
  // 	console.error(new UnknownGpsReadingPropError(message));
  // }

  // // eslint-disable-next-line no-console
  // console.warn(message);
};
const tryWarnBadProps = (keys, title) => {
  const props = Object.keys(keys);
  if (props.length === 0) {
    return;
  }
  const propsToWarn = getPropsNotWarnedYet(props);
  if (propsToWarn.length === 0) {
    return;
  }
  propsToWarn.forEach(prop => {
    propsWarned[prop] = true;
  });
  tryRaiseBadPropsErrorOrWarning(propsToWarn, title, false);
};
const tryThrowBadPropsError = (keys, title) => {
  const props = Object.keys(keys);
  tryRaiseBadPropsErrorOrWarning(props, title, true);
};
const ReadingsUtilMisc = {
  UnknownGpsReadingPropError: _UnknownGpsReadingPropError.default,
  BadLocationError: _BadLocationError.default,
  validateEmptyProps: (title, propsObject) => {
    if (isProd) {
      return;
    }
    const keys = Object.keys(propsObject);
    if (keys.length === 0) {
      return;
    }
    const {
      warningProps,
      errorProps
    } = getWarningErrorProps(propsObject);
    tryThrowBadPropsError(errorProps, title); // Do warnings first as errors will stop program
    tryWarnBadProps(warningProps, title);
  },
  cleanEmptyValues
};
var _default = ReadingsUtilMisc;
exports.default = _default;